import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

function FormRecaptcha({
  alias,
  siteKey,
  onCaptchaChange,
  inputValues,
  errMsg,
  handleErrorText,
}) {
  
  const errMsgStyles = handleErrorText(inputValues[alias]) ? 'hidden' : 'inline';

  return (
    <div className="w-full h-auto relative">
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={onCaptchaChange}
      />
      {errMsg && (
        <span className={`text-xs text-red absolute -bottom-5 left-0 ${errMsgStyles}`}>
          {errMsg}
        </span>
      )}
    </div>
  );
}

export default FormRecaptcha;
